var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticStyle:{"padding":"32px"},attrs:{"color":"#163626"}},[_c('v-col',{staticClass:"px-0 py-0 text-center",attrs:{"cols":"12"}},[_c('span',{staticClass:"footer-text"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Vivamus GmbH. Alle Rechte vorbehalten. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }